import type { SVGProps } from "react";
// generated from Gear.svg — do not edit manually
// prettier-ignore
export default function Gear(props: SVGProps<SVGSVGElement>) {
  return (<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<g clip-path="url(#clip0_4973_6764)">
<path fillRule="evenodd" clipRule="evenodd" d="M9.86833 2.67741C9.99547 3.52466 10.8769 4.03375 11.6743 3.72038L12.9399 3.22298L14.6066 6.1097L13.5435 6.95605C12.8729 7.48974 12.8725 8.50873 13.5428 9.04264L14.6066 9.88965L12.9399 12.7764L11.6743 12.279C10.8768 11.9653 9.99464 12.4744 9.86768 13.3219L9.6665 14.6663H6.33317L6.13135 13.3213C6.00401 12.474 5.12203 11.9653 4.32471 12.279L3.05973 12.7764L1.39307 9.88965L2.45687 9.04199C3.12683 8.50804 3.12648 7.48969 2.45622 6.95605L1.39307 6.1097L3.05973 3.22298L4.32471 3.72038C5.12206 4.03391 6.00411 3.52469 6.13135 2.67741L6.33317 1.33301H9.6665L9.86833 2.67741ZM7.99984 5.99967C6.89527 5.99967 5.99984 6.8951 5.99984 7.99967C5.99984 9.10424 6.89527 9.99967 7.99984 9.99967C9.10441 9.99967 9.99984 9.10424 9.99984 7.99967C9.99984 6.8951 9.10441 5.99967 7.99984 5.99967Z" stroke="#1F2737" strokeWidth="1.5"/>
</g>
<defs>
<clipPath id="clip0_4973_6764">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>);
}
